import Vue from 'vue';
import concat from 'lodash/concat';
import { apolloClient } from '@/plugins/vue-apollo';
import {
  getOrganizationByPkQuery,
  emailOrganizationContactCount,
  searchOrganizations,
} from '@/store/graphql/queries/_admin-catalog';
import { updateOrganizationMutation } from '@/store/graphql/mutations/_admin-catalog';

const organizationManager = {
  namespaced: true,
  state: {
    organization: {
      name: null,
      tax_id: null,
      contacts: [],
    },
    organizations: {
      count: 0,
      data: [],
    },
  },
  actions: {
    async get({ commit }, organizationId) {
      commit('SET_ORGANIZATION', {});
      try {
        const searchQuery = {
          query: getOrganizationByPkQuery,
          variables: {
            organizationId,
          },
        };

        const response = await apolloClient.query(searchQuery);
        if (response && response.data) {
          commit('SET_ORGANIZATION', {
            organization: response.data.organization_by_pk,
            newContacts: [],
          });
        }
      } catch (error) {
        throw new Error(error);
      }
    },
    async update({ commit, state }, data) {
      try {
        const updateMutation = {
          mutation: updateOrganizationMutation,
          variables: {
            organizationId: data.id,
            organization_set: {
              name: data.name,
              description: data.description,
              website: data.website,
              contact_name: data.contact_name,
              contact_email: data.contact_email,
              country: data.country,
              city: data.city,
              address: data.address,
              last_billing: data.last_billing,
              created_date: data.created_date,
            },
          },
        };

        const response = await apolloClient.mutate(updateMutation);
        if (response && response.data) {
          const updateOrganizationResult = response.data.update_organization.returning[0];

          commit('SET_ORGANIZATION', { organization: updateOrganizationResult });
        }
      } catch (error) {
        throw new Error(error);
      }

      return state.organization;
    },
    async emailContactExists(store, data) {
      try {
        const validateQuery = {
          query: emailOrganizationContactCount,
          variables: {
            organizationId: data.organizationId,
            email: data.email,
          },
        };

        const response = await apolloClient.query(validateQuery);
        return response.data.aggregate.count > 0;
      } catch (error) {
        throw new Error(error);
      }
    },
    async search({ commit, state }, data) {
      try {
        const searchQuery = {
          query: searchOrganizations,
          variables: {
            limit: data.limit,
            offset: data.offset,
            keyword: data.keyword,
          },
        };

        const response = await apolloClient.query(searchQuery);
        if (response && response.data) {
          commit('SET_ORGANIZATIONS', response.data);
        }

        return state.organizations;
      } catch (error) {
        throw new Error(error);
      }
    },
  },
  mutations: {
    SET_ORGANIZATION(state, { organization, newContacts }) {
      if (newContacts && newContacts.length) {
        Vue.set(organization, 'contacts', concat(organization.contacts, newContacts));
      }
      Vue.set(state, 'organization', organization);
    },
    SET_ORGANIZATIONS(state, organizations) {
      Vue.set(state.organizations, 'data', organizations.organization);
      Vue.set(state.organizations, 'count', organizations.organization_aggregate.aggregate);
    },
  },
  getters: {
    currentOrganizationInfo: state => state.organization,
    organizationsSearchInfo: state => state.organizations,
  },
};

export default organizationManager;



// WEBPACK FOOTER //
// ./src/store/modules/supplier/_admin-organization-manage.js